import React, { ChangeEvent, FC, useState } from 'react';
import { Input } from 'antd';
import {
  formatUSPhoneForDisplay,
  US_FORMATTED_PHONE_NUMBER_LENGTH,
  US_PHONE_PLACEHOLDER,
  sanitizePhoneInput,
} from 'common/helpers/phone.helper';
import { IQuestionViewPhone, QuestionWithTranslation } from 'entities/Questions/questions.model';

interface IComponentProps {
  question: QuestionWithTranslation;
  isAnotherLang: boolean;
}

export const PhoneType: FC<IComponentProps> = ({ question, isAnotherLang }) => {
  const [value, setValue] = useState<string>('');

  const placeholder: string | undefined =
    isAnotherLang && question.translations?.view?.placeholder
      ? question.translations.view.placeholder
      : (question.view as IQuestionViewPhone).placeholder;

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const cleaned = sanitizePhoneInput(e.target.value);
    const formatted = formatUSPhoneForDisplay(cleaned);

    setValue(formatted);
  };

  return (
    <div className="questions__form_common-phone">
      <Input
        className="questions__form_common-phone-filed"
        placeholder={placeholder ? placeholder : US_PHONE_PLACEHOLDER}
        maxLength={US_FORMATTED_PHONE_NUMBER_LENGTH}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
